/* global reconciliationIndexUrl locationsUrl saveAllocationUrl dropAllocationUrl typeWorkforce typeNonWorkforce taxEnabled updateTaxUrl reconciliationTotalsUrl */
/* global refreshUrl filtersUrl editableGeneralInfo updateGeneralDataUrl */
/* global configsUrl uploadUrl deleteAllUrl isFileRequired integrationConfigured syncEnabled action model toggleUrl syncNowUrl syncTypes confirmationUrl eligibleIdsUrl */

import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import classNames from 'classnames';

import ToggleActualCostsSync from '../../integrations/activation/ToggleActualCostsSync';
import DeleteActualCosts from '../DeleteActualCosts';

import ActualCostsAllocationTable from './ActualCostsAllocationTable';

import { formatDateWithTz } from 'Helpers/dateUtils';
import { formatFigure } from 'Helpers/formatService';

import Button from 'CommonComponents/Button';
import LoadingOverlay from 'CommonComponents/LoadingOverlay';
import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import TableFilterModal from 'CommonComponents/TableFilterModal';

import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';

import { useConfirmationModal } from 'Hooks/useConfirmationModal';
import { useToast } from 'Hooks/useToast';

import MinusIcon from 'Assets/icons/minus.svg';
import PlusIcon from 'Assets/icons/plus.svg';

const defaultSearchParams = {
    supplier: '',
    documentType: '',
    glCode: '',
    department: '',
    budgetLine: '',
    contractReference: '',
};

const defaultFilterParams = {
    supplier: [],
    documentType: [],
    glCode: [],
    department: [],
    budgetLine: [],
    contractReference: [],
};

export default function ActualCostsAllocationIndex(props) {
    const [departments, setDepartments] = useState({
        expenditure: [],
        revenue: [],
    });
    const [directLineItems, setDirectLineItems] = useState({});
    const [actualCostsReconciledExpenditure, setActualCostsReconciledExpenditure] = useState({});
    const [actualCostsReconciledRevenue, setActualCostsReconciledRevenue] = useState({});
    const [actualCostsUnreconciledExpenditure, setActualCostsUnreconciledExpenditure] = useState({});
    const [actualCostsUnreconciledRevenue, setActualCostsUnreconciledRevenue] = useState({});

    const [actualCostsTotals, setActualCostsTotals] = useState({
        revenue: {
            unreconciled: { number: 0, amount: 0 },
            reconciled: { number: 0, amount: 0 },
            total: { number: 0, amount: 0 },
        },
        expenditure: {
            unreconciled: { number: 0, amount: 0 },
            reconciled: { number: 0, amount: 0 },
            total: { number: 0, amount: 0 },
        },
        total: {
            unreconciled: { number: 0, amount: 0 },
            reconciled: { number: 0, amount: 0 },
            total: { number: 0, amount: 0 },
        },
    });
    const [glCodes, setGlCodes] = useState({});
    const [revenueTaxes, setRevenueTaxes] = useState([]);
    const [expenditureTaxes, setExpenditureTaxes] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [eventId, setEventId] = useState(null);
    const [allContracts, setAllContracts] = useState({});

    const [types, setTypes] = useState([]);
    const [transactionTypes, setTransactionTypes] = useState({});
    const [requestUnreconciledRevenue, setRequestUnreconciledRevenue] = useState(false);
    const [requestReconciledRevenue, setRequestReconciledRevenue] = useState(false);
    const [requestUnreconciledExpenditure, setRequestUnreconciledExpenditure] = useState(false);
    const [requestReconciledExpenditure, setRequestReconciledExpenditure] = useState(false);

    const [totalsRequest, setTotalsRequest] = useState(false);
    const [dateFilter, setDateFilter] = useState('0');
    const [glCodeFilter, setGlCodeFilter] = useState('0');

    const [locationFetched, setLocationFetched] = useState(false);

    const [fetchActualCostsTrigger, setFetchActualCostsTrigger] = useState(0);

    const [filterDates, setFilterDates] = useState([]);
    const [filterCodes, setFilterCodes] = useState([]);
    const [fetched, setFetched] = useState(false);

    const [configs, setConfigs] = useState({});

    const [collapsed, setCollapsed] = useState({
        unreconciledRevenue: true,
        unreconciledExpenditure: true,
        reconciledRevenue: true,
        reconciledExpenditure: true,
    });
    const [collapsedSummary, setCollapsedSummary] = useState(true);

    const [paginationUnreconciledRevenue, setPaginationUnreconciledRevenue] = useState({
        perPage: 20,
        page: 1,
        lastPage: 1,
        to: 1,
        from: 1,
        total: 1,
    });
    const [paginationReconciledRevenue, setPaginationReconciledRevenue] = useState({
        perPage: 20,
        page: 1,
        lastPage: 1,
        to: 1,
        from: 1,
        total: 1,
    });
    const [paginationUnreconciledExpenditure, setPaginationUnreconciledExpenditure] = useState({
        perPage: 20,
        page: 1,
        lastPage: 1,
        to: 1,
        from: 1,
        total: 1,
    });
    const [paginationReconciledExpenditure, setPaginationReconciledExpenditure] = useState({
        perPage: 20,
        page: 1,
        lastPage: 1,
        to: 1,
        from: 1,
        total: 1,
    });

    const [filtersUnreconciledRevenue, setFiltersUnreconciledRevenue] = useState({
        filters: JSON.parse(JSON.stringify(defaultFilterParams)),
        search: JSON.parse(JSON.stringify(defaultSearchParams)),
    });
    const [filtersReconciledRevenue, setFiltersReconciledRevenue] = useState({
        filters: JSON.parse(JSON.stringify(defaultFilterParams)),
        search: JSON.parse(JSON.stringify(defaultSearchParams)),
    });
    const [filtersUnreconciledExpenditure, setFiltersUnreconciledExpenditure] = useState({
        filters: JSON.parse(JSON.stringify(defaultFilterParams)),
        search: JSON.parse(JSON.stringify(defaultSearchParams)),
    });
    const [filtersReconciledExpenditure, setFiltersReconciledExpenditure] = useState({
        filters: JSON.parse(JSON.stringify(defaultFilterParams)),
        search: JSON.parse(JSON.stringify(defaultSearchParams)),
    });

    const [tableFilters, setTableFilters] = useState({
        expense: {
            reconciled: {},
            unreconciled: {},
        },
        revenue: {
            reconciled: {},
            unreconciled: {},
        },
    });

    const requestsRef = useRef({});
    const toast = useToast();
    const confirm = useConfirmationModal();

    useEffect(() => {
        fetchLocations().then(() => {
            fetchFilters();
            setLocationFetched(true);
            setFetchActualCostsTrigger(fetchActualCostsTrigger + 1);
        });
        fetchConfigs();
    }, []);

    useEffect(() => {
        return () => {
            Object.values(requestsRef.current).forEach((c) => {
                try {
                    c.abort();
                } catch (e) {
                    // Ignore abort errors
                }
            });
        };
    }, []);

    useEffect(() => {
        if (locationFetched) {
            fetchAll();
            fetchTotals();
        }
    }, [fetchActualCostsTrigger]);

    const toggleCollapsed = (key) => {
        const options = JSON.parse(JSON.stringify(collapsed));
        if (key in options) {
            options[key] = !options[key];
        }

        setCollapsed(options);
    };

    const getDataToUpdate = (type, reconciled) => {
        if (type === 'revenue') {
            return reconciled ? JSON.parse(JSON.stringify(actualCostsReconciledRevenue)) : JSON.parse(JSON.stringify(actualCostsUnreconciledRevenue));
        }

        return reconciled ? JSON.parse(JSON.stringify(actualCostsReconciledExpenditure)) : JSON.parse(JSON.stringify(actualCostsUnreconciledExpenditure));
    };

    const fetchFilters = () => {
        return axios
            .get(props.filtersUrl)
            .then((response) => {
                setTableFilters(response.data.filters);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const fetchConfigs = () => {
        return axios
            .get(props.configsUrl)
            .then((response) => {
                setConfigs(response.data);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const fetchLocations = () => {
        return axios
            .get(props.locationsUrl)
            .then((res) => {
                const { data } = res;
                setExpenditureTaxes(data.expenditureTaxes);
                setRevenueTaxes(data.revenueTaxes);
                setEventId(data.eventId);
                setAllContracts(data.allContracts);

                const departmentsData = {
                    expense: [],
                    revenue: [],
                };
                const lineItemsData = {};

                data.departments.forEach((department) => {
                    const name = department.name;
                    const type = department.type;
                    const id = department.typed_id;

                    const depObj = {
                        name,
                        id: department.id,
                        type,
                        typed_id: id,
                    };
                    departmentsData[type].push(depObj);
                    lineItemsData[id] = {
                        [props.typeWorkforce]: [],
                        [props.typeNonWorkforce]: [],
                    };

                    const datum = JSON.parse(JSON.stringify(department.directLineItems));
                    datum.forEach((item) => {
                        if (item.type === props.typeWorkforce) {
                            lineItemsData[id][props.typeWorkforce].push(item);
                        } else {
                            lineItemsData[id][props.typeNonWorkforce].push(item);
                        }
                    });

                    if ('costcenters' in department) {
                        department.costcenters.forEach((cc) => {
                            const ccName = department.name + ' / ' + cc.name;
                            const ccId = cc.typed_id;

                            const ccObj = {
                                name: ccName,
                                id: cc.id,
                                type,
                                typed_id: ccId,
                            };

                            departmentsData[type].push(ccObj);
                            lineItemsData[ccId] = {
                                [props.typeWorkforce]: [],
                                [props.typeNonWorkforce]: [],
                            };

                            const ccDatum = JSON.parse(JSON.stringify(cc.directLineItems));
                            ccDatum.forEach((item) => {
                                if (item.type === props.typeWorkforce) {
                                    lineItemsData[ccId][props.typeWorkforce].push(item);
                                } else {
                                    lineItemsData[ccId][props.typeNonWorkforce].push(item);
                                }
                            });
                        });
                    }
                });

                setFilterDates(data.filterDates);
                setFilterCodes(data.filterCodes);
                setGlCodes(data.glCodes);
                setTypes(data.types);
                setSuppliers(data.suppliers);
                setTransactionTypes(data.transactionTypes);
                setDepartments(departmentsData);
                setDirectLineItems(lineItemsData);
                setFetched(true);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const editActualCostGeneralInfoItem = (reconciled, group, month, index, key, value) => {
        let data = null;

        if (reconciled) {
            data =
                group === 'revenue' ? JSON.parse(JSON.stringify(actualCostsReconciledRevenue)) : JSON.parse(JSON.stringify(actualCostsReconciledExpenditure));
        } else {
            data =
                group === 'revenue'
                    ? JSON.parse(JSON.stringify(actualCostsUnreconciledRevenue))
                    : JSON.parse(JSON.stringify(actualCostsUnreconciledExpenditure));
        }

        if (data) {
            data[month][index][key] = value;

            if (reconciled) {
                if (group === 'revenue') {
                    setActualCostsReconciledRevenue(data);
                } else {
                    setActualCostsReconciledExpenditure(data);
                }
            } else {
                if (group === 'revenue') {
                    setActualCostsUnreconciledRevenue(data);
                } else {
                    setActualCostsUnreconciledExpenditure(data);
                }
            }
        }
    };

    const saveGeneralInfo = (reconciled, group, id, callback = null, callback2 = null) => {
        let data = null;
        const opposite = reconciled ? 0 : 1;

        if (reconciled) {
            data =
                group === 'revenue' ? JSON.parse(JSON.stringify(actualCostsReconciledRevenue)) : JSON.parse(JSON.stringify(actualCostsReconciledExpenditure));
        } else {
            data =
                group === 'revenue'
                    ? JSON.parse(JSON.stringify(actualCostsUnreconciledRevenue))
                    : JSON.parse(JSON.stringify(actualCostsUnreconciledExpenditure));
        }

        let item = null;
        Object.keys(data).forEach((month) => {
            const datum = data[month];
            datum.forEach((row) => {
                if (row.id === id) {
                    item = row;
                }
            });
        });

        if (item) {
            const url = props.updateGeneralDataUrl.replace('ACTUAL_COST_ID', item.id);

            const requestData = {
                transaction_description: item.transaction_description,
                amount: item.amount,
                document_type: item.document_type,
                document_number: item.document_number,
                date: item.date,
                gl_code: item.gl_code,
                supplier: item.supplier,
            };

            axios
                .put(url, requestData)
                .then((response) => {
                    fetchData(group, reconciled).then(() => {
                        if (callback2 && typeof callback === 'function') {
                            callback2();
                        }
                    });
                    fetchData(group, opposite);
                    toast.success($t('Actual Costs updated successfully.'));
                })
                .catch((error) => {
                    const message = error.response?.data?.message || $t('Something went wrong.');
                    toast.error(message);
                });
        }

        if (callback && typeof callback === 'function') {
            callback();
        }
    };

    const resetEdit = (reconciled, group, month, index, oldData) => {
        let data = null;
        if (reconciled) {
            data =
                group === 'revenue' ? JSON.parse(JSON.stringify(actualCostsReconciledRevenue)) : JSON.parse(JSON.stringify(actualCostsReconciledExpenditure));
        } else {
            data =
                group === 'revenue'
                    ? JSON.parse(JSON.stringify(actualCostsUnreconciledRevenue))
                    : JSON.parse(JSON.stringify(actualCostsUnreconciledExpenditure));
        }

        const item = data[month][index];
        item.transaction_description = oldData.transaction_description;
        item.amount = oldData.amount;
        item.document_type = oldData.document_type;
        item.document_number = oldData.document_number;
        item.date = oldData.date;
        item.gl_code = oldData.gl_code;
        item.supplier_name = oldData.supplier_name;
        item.supplier = oldData.supplier;

        data[month][index] = item;

        if (reconciled) {
            if (group === 'revenue') {
                setActualCostsReconciledRevenue(data);
            } else {
                setActualCostsReconciledExpenditure(data);
            }
        } else {
            if (group === 'revenue') {
                setActualCostsUnreconciledRevenue(data);
            } else {
                setActualCostsUnreconciledExpenditure(data);
            }
        }
    };

    const setActualCostsGroupData = (reconciled, group, data) => {
        if (reconciled) {
            if (group === 'revenue') {
                setActualCostsReconciledRevenue(data);
            } else {
                setActualCostsReconciledExpenditure(data);
            }
        } else {
            if (group === 'revenue') {
                setActualCostsUnreconciledRevenue(data);
            } else {
                setActualCostsUnreconciledExpenditure(data);
            }
        }
    };

    const setPagination = (type, reconciled, paginationData) => {
        const current = getPagination(type, reconciled);
        const next = {
            ...current,
            total: paginationData.total,
            lastPage: paginationData.last_page,
            from: paginationData.from,
            to: paginationData.to,
            perPage: paginationData.per_page,
            page: paginationData.current_page,
        };

        if (!isSamePagination(current, next)) {
            setPaginationData(type, reconciled, next);
        }
    };

    const setPaginationPage = (type, reconciled, page) => {
        let pagination = getPagination(type, reconciled);
        pagination.page = page;
        setPaginationData(type, reconciled, pagination);
    };

    const setPaginationPerPage = (type, reconciled, perPage) => {
        let pagination = getPagination(type, reconciled);
        pagination.perPage = perPage;
        setPaginationData(type, reconciled, pagination);
    };

    const getPagination = (type, reconciled) => {
        if (type === 'revenue') {
            return reconciled ? JSON.parse(JSON.stringify(paginationReconciledRevenue)) : JSON.parse(JSON.stringify(paginationUnreconciledRevenue));
        } else {
            return reconciled ? JSON.parse(JSON.stringify(paginationReconciledExpenditure)) : JSON.parse(JSON.stringify(paginationUnreconciledExpenditure));
        }
    };

    const isSamePagination = (a, b) => {
        return a.total === b.total && a.lastPage === b.lastPage && a.from === b.from && a.to === b.to && a.perPage === b.perPage && a.page === b.page;
    };

    const setPaginationData = (type, reconciled, data) => {
        if (type === 'revenue') {
            if (reconciled) {
                setPaginationReconciledRevenue(data);
            } else {
                setPaginationUnreconciledRevenue(data);
            }
        } else {
            if (reconciled) {
                setPaginationReconciledExpenditure(data);
            } else {
                setPaginationUnreconciledExpenditure(data);
            }
        }
    };

    useEffect(() => {
        fetchData('revenue', 1);
    }, [paginationReconciledRevenue.page, paginationReconciledRevenue.perPage]);
    useEffect(() => {
        fetchData('revenue', 0);
    }, [paginationUnreconciledRevenue.page, paginationUnreconciledRevenue.perPage]);
    useEffect(() => {
        fetchData('expense', 1);
    }, [paginationReconciledExpenditure.page, paginationReconciledExpenditure.perPage]);
    useEffect(() => {
        fetchData('expense', 0);
    }, [paginationUnreconciledExpenditure.page, paginationUnreconciledExpenditure.perPage]);

    useEffect(() => {
        if (paginationReconciledRevenue.page === 1) {
            fetchData('revenue', 1);
        } else {
            setPaginationPage('revenue', 1, 1);
        }
    }, [filtersReconciledRevenue]);
    useEffect(() => {
        if (paginationUnreconciledRevenue.page === 1) {
            fetchData('revenue', 0);
        } else {
            setPaginationPage('revenue', 0, 1);
        }
    }, [filtersUnreconciledRevenue]);
    useEffect(() => {
        if (paginationReconciledExpenditure.page === 1) {
            fetchData('expense', 1);
        } else {
            setPaginationPage('expense', 1, 1);
        }
    }, [filtersReconciledExpenditure]);
    useEffect(() => {
        if (paginationUnreconciledExpenditure.page === 1) {
            fetchData('expense', 0);
        } else {
            setPaginationPage('expense', 0, 1);
        }
    }, [filtersUnreconciledExpenditure]);

    const applyFilters = (key, value, isFilter, type, reconciled) => {
        const group = isFilter ? 'filters' : 'search';

        let data = {};
        let setter = () => {};
        if (reconciled) {
            data = type === 'revenue' ? JSON.parse(JSON.stringify(filtersReconciledRevenue)) : JSON.parse(JSON.stringify(filtersReconciledExpenditure));
            setter = type === 'revenue' ? setFiltersReconciledRevenue : setFiltersReconciledExpenditure;
        } else {
            data = type === 'revenue' ? JSON.parse(JSON.stringify(filtersUnreconciledRevenue)) : JSON.parse(JSON.stringify(filtersUnreconciledExpenditure));
            setter = type === 'revenue' ? setFiltersUnreconciledRevenue : setFiltersUnreconciledExpenditure;
        }
        data[group][key] = value;
        setter(data);
    };

    const getFilters = (type, reconciled) => {
        if (reconciled) {
            return type === 'revenue' ? filtersReconciledRevenue : filtersReconciledExpenditure;
        }

        return type === 'revenue' ? filtersUnreconciledRevenue : filtersUnreconciledExpenditure;
    };

    const fetchAll = (callback = null) => {
        fetchData('revenue', 0, callback);
        fetchData('expense', 0, callback);
        fetchData('revenue', 1, callback);
        fetchData('expense', 1, callback);
    };

    const setRequest = (type, reconciled, value) => {
        if (reconciled) {
            if (type === 'revenue') {
                setRequestReconciledRevenue(value);
            } else {
                setRequestReconciledExpenditure(value);
            }
        } else {
            if (type === 'revenue') {
                setRequestUnreconciledRevenue(value);
            } else {
                setRequestUnreconciledExpenditure(value);
            }
        }
    };

    const fetchData = (type, reconciled, callback = null) => {
        const pagination = getPagination(type, reconciled);
        setRequest(type, reconciled, true);
        let url = new URL(props.indexUrl);
        let params = new URLSearchParams(url.search);

        params.set('type', type);
        params.set('reconciled', reconciled);
        params.set('date', dateFilter);
        params.set('gl_code', glCodeFilter);
        params.set('page', pagination.page);
        params.set('per_page', pagination.perPage);

        const key = `${type}:${reconciled}`;
        try {
            requestsRef.current[key]?.abort();
        } catch (e) {
            // Ignore abort errors
        }
        const controller = new AbortController();
        requestsRef.current[key] = controller;

        const payload = {
            filtersAndSearch: getFilters(type, reconciled),
        };

        return axios
            .post(props.indexUrl + '?' + params.toString(), payload, { signal: controller.signal })
            .then((res) => {
                const { data } = res;

                setPagination(type, reconciled, data.meta);
                setActualCostsGroupData(reconciled, type, data.data);
                if (callback && typeof callback === 'function') {
                    callback();
                }
            })
            .catch((e) => {
                if (e?.name === 'CanceledError' || e?.code === 'ERR_CANCELED' || e?.message === 'canceled') {
                    return;
                }
                console.log(e);
            })
            .finally(() => {
                setRequest(type, reconciled, false);
                if (requestsRef.current[key] === controller) {
                    delete requestsRef.current[key];
                }
            });
    };

    const fetchTotals = () => {
        setTotalsRequest(true);
        let url = new URL(props.totalsUrl);
        let params = new URLSearchParams(url.search);

        params.set('date', dateFilter);
        params.set('gl_code', glCodeFilter);

        const uri = url.origin + url.pathname + '?' + params.toString();

        return axios
            .get(uri)
            .then((res) => {
                const { data } = res;

                setActualCostsTotals(data.totals);
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                setTotalsRequest(false);
            });
    };

    const processActualCostsAfterAllocation = (item, oldData, callback = null) => {
        const group = item.reconciled ? 'reconciled' : 'unreconciled';
        const oldGroup = oldData.reconciled ? 'reconciled' : 'unreconciled';

        const subGroup = item.type === 'revenue' ? 'revenue' : 'expenditure';
        const month = item.month;
        const oldMonth = oldData.month;

        let groupDatum = getDataToUpdate(subGroup, group === 'reconciled');
        let oldGroupDatum = getDataToUpdate(subGroup, oldGroup === 'reconciled');

        if (group === oldGroup) {
            const monthData = groupDatum[month];
            groupDatum[month] = monthData.map((row) => (row.id === item.id ? item : row));

            setActualCostsGroupData(group === 'reconciled', subGroup, groupDatum);
        } else {
            const oldMontData = oldGroupDatum[oldMonth];
            const updatedOldMontData = oldMontData.filter((row) => row.id !== item.id);
            oldGroupDatum[oldMonth] = updatedOldMontData;

            setActualCostsGroupData(oldGroup === 'reconciled', subGroup, oldGroupDatum);

            const newMonthData = groupDatum[month] ?? [];
            newMonthData.push(item);
            groupDatum[month] = newMonthData;

            setActualCostsGroupData(group === 'reconciled', subGroup, groupDatum);
        }

        fetchTotals();

        if (callback && typeof callback === 'function') {
            callback();
        }
    };

    const resetFilters = () => {
        setDateFilter('0');
        setGlCodeFilter('0');
        setFetchActualCostsTrigger(fetchActualCostsTrigger + 1);
    };

    const setActualCostsItem = (group, type, month, index, row) => {
        const data = getDataToUpdate(type, group === 'reconciled');
        data[month][index] = row;

        setActualCostsGroupData(group === 'reconciled', type, data);
    };

    const combineRefreshUrl = (type) => {
        const url = new URL(props.refreshUrl);
        url.searchParams.set('type', type);

        return url.toString();
    };

    const postActualCostsConfirmations = (payload) => {
        return axios.post(props.confirmationUrl, payload);
    };

    const confirmActualCosts = (payload, type, skippedCount = 0) => {
        return new Promise((resolve, reject) => {
            const pending = payload?.pending ?? [];
            const ids = payload?.ids ?? [];
            const totalItems = pending.length + ids.length;

            if (totalItems === 0) {
                return resolve([]);
            }

            const message =
                skippedCount > 0
                    ? $t(
                          'The fields can still be adjusted in the reconciled table after confirmation. {{skipped}} item(s) were skipped because they are missing required fields.',
                          { skipped: skippedCount },
                      )
                    : $t('The fields can still be adjusted in the reconciled table after confirmation.');

            confirm({
                title: $t('{{count}} Items to Confirm', { count: totalItems }),
                message,
                onConfirm: () => {
                    postActualCostsConfirmations({ pending, ids })
                        .then((res) => {
                            const confirmed = res.data?.confirmed ?? [];
                            const skipped = res.data?.skipped ?? [];

                            fetchData(type, 0);
                            fetchData(type, 1);
                            fetchTotals();

                            if (confirmed.length > 0 && skipped.length === 0) {
                                toast.success($t('{{count}} item(s) confirmed successfully.', { count: confirmed.length }));
                            } else if (confirmed.length > 0 && skipped.length > 0) {
                                toast.success(
                                    $t('{{confirmed}} item(s) confirmed. {{skipped}} item(s) could not be confirmed automatically.', {
                                        confirmed: confirmed.length,
                                        skipped: skipped.length,
                                    }),
                                );
                            } else if (confirmed.length === 0 && skipped.length > 0) {
                                toast.warning(
                                    $t('No items were confirmed. {{skipped}} item(s) could not be confirmed automatically.', { skipped: skipped.length }),
                                );
                            }

                            resolve(confirmed);
                        })
                        .catch((e) => {
                            const message = e.response?.data?.message || $t('Something went wrong during confirmation.');
                            toast.error(message);
                            reject(new Error(message));
                        });
                },
                onCancel: () => {
                    resolve(null);
                },
            });
        });
    };

    return (
        <div className="tw-h-full tw-flex tw-flex-col tw-gap-y-10">
            <div className="tw-flex-initial tw-flex tw-items-center tw-justify-between tw-px-6 -tw-mx-4 tw-border-b tw-border-b-charcoal-15">
                <div className="tw-h-14 tw-flex tw-items-center tw-gap-x-8">
                    <div className="tw-flex tw-items-baseline tw-gap-x-2 tw-text-sm">
                        <div className="tw-font-semibold">{$t('Import Date')}</div>
                        <div>{formatDateWithTz(configs.uploadDate, 'YYYY-MM-DD', 'DD/MM/YYYY')}</div>
                    </div>
                    <div className="tw-flex tw-items-baseline tw-gap-x-2 tw-text-sm">
                        <div className="tw-font-semibold">{$t('Earliest Transaction')}</div>
                        <div>{formatDateWithTz(configs.earliestTransaction, 'YYYY-MM-DD', 'DD/MM/YYYY')}</div>
                    </div>
                    <div className="tw-flex tw-items-baseline tw-gap-x-2 tw-text-sm">
                        <div className="tw-font-semibold">{$t('Most Recent Transaction')}</div>
                        <div>{formatDateWithTz(configs.mostRecentTransaction, 'YYYY-MM-DD', 'DD/MM/YYYY')}</div>
                    </div>
                </div>
                <div>
                    {!props.integrationConfigured && (
                        <div className="tw-flex tw-items-center tw-gap-x-2">
                            <Button as="a" variant="primary" href={props.uploadUrl}>
                                {$t('Import Actuals from Excel')}
                            </Button>
                            {!props.isFileRequired && <DeleteActualCosts url={props.deleteAllUrl} />}
                        </div>
                    )}

                    <ToggleActualCostsSync
                        integrationConfigured={props.integrationConfigured}
                        syncEnabled={props.syncEnabled}
                        action={props.action}
                        toggleUrl={props.toggleUrl}
                        model={props.model}
                        syncNowUrl={props.syncNowUrl}
                        toggleCallback={() => {
                            window.location.reload();
                        }}
                        syncTypes={props.syncTypes}
                    />
                </div>
            </div>
            <div className="table__card tw-mb-5">
                <div className="tw-flex tw-justify-center">
                    <div
                        className={classNames('inbud-table_wrapper', 'tw-overflow-auto', 'max-h-50vh', 'tw-relative', !collapsedSummary && '!tw-hidden')}
                        style={{ width: '90%' }}
                    >
                        <LoadingOverlay isVisible={totalsRequest || fetchActualCostsTrigger === 0} />
                        <table className="inbud-table tw-w-full">
                            <thead>
                                <tr>
                                    <th className="!tw-align-middle tw-border-r-2 tw-border-b-2 tw-w-1/4" rowSpan={2} colSpan={2}></th>
                                    <th className="!tw-align-middle tw-border-r-2 tw-border-b-2 tw-w-1/4" colSpan={2}>
                                        {$t('Unreconciled')}
                                    </th>
                                    <th className="!tw-align-middle tw-border-r-2 tw-border-b-2 tw-w-1/4" colSpan={2}>
                                        {$t('Reconciled')}
                                    </th>
                                    <th className="!tw-align-middle tw-border-r-2 tw-border-b-2 tw-w-1/4" colSpan={2}>
                                        {$t('Total')}
                                    </th>
                                </tr>
                                <tr>
                                    <th className="!tw-align-middle tw-border-r-2 tw-border-b-2 tw-w-[12.5%]">{$t('Value')}</th>
                                    <th className="!tw-align-middle tw-border-r-2 tw-border-b-2 tw-w-[12.5%]">{$t('Items')}</th>
                                    <th className="!tw-align-middle tw-border-r-2 tw-border-b-2 tw-w-[12.5%]">{$t('Value')}</th>
                                    <th className="!tw-align-middle tw-border-r-2 tw-border-b-2 tw-w-[12.5%]">{$t('Items')}</th>
                                    <th className="!tw-align-middle tw-border-r-2 tw-border-b-2 tw-w-[12.5%]">{$t('Value')}</th>
                                    <th className="!tw-align-middle tw-border-r-2 tw-border-b-2 tw-w-[12.5%]">{$t('Items')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan={2}>{$t('Revenue')}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.revenue.unreconciled.amount)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.revenue.unreconciled.number, String)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.revenue.reconciled.amount)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.revenue.reconciled.number, String)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.revenue.total.amount)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.revenue.total.number, String)}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>{$t('Expenditure')}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.expenditure.unreconciled.amount)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.expenditure.unreconciled.number, String)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.expenditure.reconciled.amount)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.expenditure.reconciled.number, String)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.expenditure.total.amount)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.expenditure.total.number, String)}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>{$t('Total')}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.total.unreconciled.amount)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.total.unreconciled.number, String)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.total.reconciled.amount)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.total.reconciled.number, String)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.total.total.amount)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(actualCostsTotals.total.total.number, String)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="tw-flex tw-justify-between tw-gap-x-1.5">
                    <div>
                        <TableFilterModal
                            id="project-plan-table_filter-modal"
                            onCancel={resetFilters}
                            showCancel={true}
                            onApply={() => setFetchActualCostsTrigger(fetchActualCostsTrigger + 1)}
                        >
                            <div>
                                <label htmlFor="status" className="tw-block tw-text-xs tw-mb-2.5">
                                    {$t('GL Code')}:
                                </label>
                                <select
                                    className="select select-input !tw-bg-white !tw-border"
                                    value={glCodeFilter}
                                    onChange={(e) => setGlCodeFilter(e.target.value)}
                                    style={{
                                        paddingLeft: '8px',
                                        paddingBottom: '2px',
                                        paddingTop: '2px',
                                        paddingRight: '30px',
                                        fontSize: '12px',
                                    }}
                                >
                                    <option value={'0'}>{$t('All codes')}</option>
                                    {filterCodes.map((code) => {
                                        return (
                                            <option key={code.id} value={code.code}>
                                                {code.code + ': ' + code.name}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                            <div>
                                <label htmlFor="status" className="tw-block tw-text-xs tw-mb-2.5">
                                    {$t('Month')}:
                                </label>
                                <select
                                    className="select select-input !tw-bg-white !tw-border"
                                    value={dateFilter}
                                    onChange={(e) => setDateFilter(e.target.value)}
                                    style={{
                                        paddingLeft: '8px',
                                        paddingBottom: '2px',
                                        paddingTop: '2px',
                                        paddingRight: '30px',
                                        fontSize: '12px',
                                    }}
                                >
                                    <option value={'0'}>{$t('All months')}</option>
                                    {filterDates.map((date) => {
                                        return (
                                            <option key={date} value={date}>
                                                {date}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </TableFilterModal>
                    </div>
                    <button className="table__icon-btn tw-text-white" onClick={() => setCollapsedSummary(!collapsedSummary)}>
                        {!collapsedSummary && <PlusIcon className="tw-w-3.5 tw-h-3.5" />}
                        {collapsedSummary && <MinusIcon className="tw-w-3.5 tw-h-3.5" />}
                    </button>
                </div>
            </div>
            {!fetched && <LoadingSpinner />}
            {fetched && (
                <>
                    <ActualCostsAllocationTable
                        glCodes={glCodes}
                        departments={departments}
                        directLineItems={directLineItems}
                        data={_.isObject(actualCostsUnreconciledRevenue) ? actualCostsUnreconciledRevenue : {}}
                        header={$t('Unreconciled Revenue')}
                        saveAllocationUrl={saveAllocationUrl}
                        fetchData={(callback) => fetchData('revenue', 0, callback)}
                        fetchTotals={fetchTotals}
                        request={requestUnreconciledRevenue}
                        dropAllocationUrl={props.dropAllocationUrl}
                        types={types}
                        transactionTypes={transactionTypes}
                        typeWorkforce={props.typeWorkforce}
                        typeNonWorkforce={props.typeNonWorkforce}
                        taxEnabled={props.taxEnabled}
                        taxes={revenueTaxes}
                        updateTaxUrl={props.updateTaxUrl}
                        setActualCostsItem={(month, index, data) => {
                            setActualCostsItem('unreconciled', 'revenue', month, index, data);
                        }}
                        toggleCollapsed={() => toggleCollapsed('unreconciledRevenue')}
                        collapsed={collapsed.unreconciledRevenue}
                        suppliers={suppliers}
                        storeKey={eventId + '_unreconciled' + '_revenues'}
                        processActualCostsAfterAllocation={processActualCostsAfterAllocation}
                        allContracts={allContracts}
                        refreshUrl={combineRefreshUrl('revenue')}
                        pagination={paginationUnreconciledRevenue}
                        setPaginationPage={(page) => setPaginationPage('revenue', 0, page)}
                        setPaginationPerPage={(perPage) => setPaginationPerPage('revenue', 0, perPage)}
                        filters={filtersUnreconciledRevenue}
                        setFilters={(key, value, isFilter) => applyFilters(key, value, isFilter, 'revenue', false)}
                        tableFilters={tableFilters.revenue.unreconciled}
                        actualCostType={'revenue'}
                        isReconciled={false}
                        fetchFilters={fetchFilters}
                        editableGeneralInfo={editableGeneralInfo}
                        editActualCostGeneralInfoItem={(month, index, key, value) => editActualCostGeneralInfoItem(0, 'revenue', month, index, key, value)}
                        resetEdit={(month, index, oldData) => resetEdit(0, 'revenue', month, index, oldData)}
                        saveGeneralInfo={(id, callback) => saveGeneralInfo(0, 'revenue', id, callback)}
                        toast={toast}
                        confirmActualCosts={confirmActualCosts}
                        eligibleIdsUrl={props.eligibleIdsUrl}
                        dateFilter={dateFilter}
                        glCodeFilter={glCodeFilter}
                    />
                    <ActualCostsAllocationTable
                        glCodes={glCodes}
                        departments={departments}
                        directLineItems={directLineItems}
                        data={_.isObject(actualCostsUnreconciledExpenditure) ? actualCostsUnreconciledExpenditure : {}}
                        header={$t('Unreconciled Expenditure')}
                        saveAllocationUrl={saveAllocationUrl}
                        fetchData={(callback) => fetchData('expense', 0, callback)}
                        fetchTotals={fetchTotals}
                        request={requestUnreconciledExpenditure}
                        dropAllocationUrl={props.dropAllocationUrl}
                        types={types}
                        transactionTypes={transactionTypes}
                        typeWorkforce={props.typeWorkforce}
                        typeNonWorkforce={props.typeNonWorkforce}
                        taxEnabled={props.taxEnabled}
                        taxes={expenditureTaxes}
                        updateTaxUrl={props.updateTaxUrl}
                        setActualCostsItem={(month, index, data) => {
                            setActualCostsItem('unreconciled', 'expenditure', month, index, data);
                        }}
                        toggleCollapsed={() => toggleCollapsed('unreconciledExpenditure')}
                        collapsed={collapsed.unreconciledExpenditure}
                        suppliers={suppliers}
                        storeKey={eventId + '_unreconciled' + '_expenditure'}
                        processActualCostsAfterAllocation={processActualCostsAfterAllocation}
                        allContracts={allContracts}
                        refreshUrl={combineRefreshUrl('expense')}
                        pagination={paginationUnreconciledExpenditure}
                        setPaginationPage={(page) => setPaginationPage('expense', 0, page)}
                        setPaginationPerPage={(perPage) => setPaginationPerPage('expense', 0, perPage)}
                        filters={filtersUnreconciledExpenditure}
                        setFilters={(key, value, isFilter) => applyFilters(key, value, isFilter, 'expense', false)}
                        tableFilters={tableFilters.expense.unreconciled}
                        actualCostType={'expense'}
                        isReconciled={false}
                        fetchFilters={fetchFilters}
                        editableGeneralInfo={editableGeneralInfo}
                        editActualCostGeneralInfoItem={(month, index, key, value) => editActualCostGeneralInfoItem(0, 'expenditure', month, index, key, value)}
                        resetEdit={(month, index, oldData) => resetEdit(0, 'expenditure', month, index, oldData)}
                        saveGeneralInfo={(id, callback) => saveGeneralInfo(0, 'expense', id, callback)}
                        toast={toast}
                        confirmActualCosts={confirmActualCosts}
                        eligibleIdsUrl={props.eligibleIdsUrl}
                        dateFilter={dateFilter}
                        glCodeFilter={glCodeFilter}
                    />
                    <div className="tw-h-10" />
                    <ActualCostsAllocationTable
                        glCodes={glCodes}
                        departments={departments}
                        directLineItems={directLineItems}
                        data={_.isObject(actualCostsReconciledRevenue) ? actualCostsReconciledRevenue : {}}
                        header={$t('Reconciled Revenue')}
                        saveAllocationUrl={saveAllocationUrl}
                        fetchData={(callback) => fetchData('revenue', 1, callback)}
                        fetchTotals={fetchTotals}
                        request={requestReconciledRevenue}
                        dropAllocationUrl={props.dropAllocationUrl}
                        types={types}
                        transactionTypes={transactionTypes}
                        typeWorkforce={props.typeWorkforce}
                        typeNonWorkforce={props.typeNonWorkforce}
                        taxEnabled={props.taxEnabled}
                        taxes={revenueTaxes}
                        updateTaxUrl={props.updateTaxUrl}
                        setActualCostsItem={(month, index, data) => {
                            setActualCostsItem('reconciled', 'revenue', month, index, data);
                        }}
                        toggleCollapsed={() => toggleCollapsed('reconciledRevenue')}
                        collapsed={collapsed.reconciledRevenue}
                        suppliers={suppliers}
                        storeKey={eventId + '_reconciled' + '_revenue'}
                        processActualCostsAfterAllocation={processActualCostsAfterAllocation}
                        allContracts={allContracts}
                        refreshUrl={combineRefreshUrl('revenue')}
                        pagination={paginationReconciledRevenue}
                        setPaginationPage={(page) => setPaginationPage('revenue', 1, page)}
                        setPaginationPerPage={(perPage) => setPaginationPerPage('revenue', 1, perPage)}
                        filters={filtersReconciledRevenue}
                        setFilters={(key, value, isFilter) => applyFilters(key, value, isFilter, 'revenue', true)}
                        tableFilters={tableFilters.revenue.reconciled}
                        actualCostType={'revenue'}
                        isReconciled={true}
                        fetchFilters={fetchFilters}
                        editableGeneralInfo={editableGeneralInfo}
                        editActualCostGeneralInfoItem={(month, index, key, value) => editActualCostGeneralInfoItem(1, 'revenue', month, index, key, value)}
                        resetEdit={(month, index, oldData) => resetEdit(1, 'revenue', month, index, oldData)}
                        saveGeneralInfo={(id, callback) => saveGeneralInfo(1, 'revenue', id, callback)}
                        toast={toast}
                    />
                    <ActualCostsAllocationTable
                        glCodes={glCodes}
                        departments={departments}
                        directLineItems={directLineItems}
                        data={_.isObject(actualCostsReconciledExpenditure) ? actualCostsReconciledExpenditure : {}}
                        header={$t('Reconciled Expenditure')}
                        saveAllocationUrl={saveAllocationUrl}
                        fetchData={(callback) => fetchData('expense', 1, callback)}
                        fetchTotals={fetchTotals}
                        request={requestReconciledExpenditure}
                        dropAllocationUrl={props.dropAllocationUrl}
                        types={types}
                        transactionTypes={transactionTypes}
                        typeWorkforce={props.typeWorkforce}
                        typeNonWorkforce={props.typeNonWorkforce}
                        taxEnabled={props.taxEnabled}
                        taxes={expenditureTaxes}
                        updateTaxUrl={props.updateTaxUrl}
                        setActualCostsItem={(month, index, data) => {
                            setActualCostsItem('reconciled', 'expenditure', month, index, data);
                        }}
                        toggleCollapsed={() => toggleCollapsed('reconciledExpenditure')}
                        collapsed={collapsed.reconciledExpenditure}
                        suppliers={suppliers}
                        storeKey={eventId + '_reconciled' + '_expenditure'}
                        processActualCostsAfterAllocation={processActualCostsAfterAllocation}
                        allContracts={allContracts}
                        refreshUrl={combineRefreshUrl('expense')}
                        pagination={paginationReconciledExpenditure}
                        setPaginationPage={(page) => setPaginationPage('expense', 1, page)}
                        setPaginationPerPage={(perPage) => setPaginationPerPage('expense', 1, perPage)}
                        filters={filtersReconciledExpenditure}
                        setFilters={(key, value, isFilter) => applyFilters(key, value, isFilter, 'expense', true)}
                        tableFilters={tableFilters.expense.reconciled}
                        actualCostType={'expense'}
                        isReconciled={true}
                        fetchFilters={fetchFilters}
                        editableGeneralInfo={editableGeneralInfo}
                        editActualCostGeneralInfoItem={(month, index, key, value) => editActualCostGeneralInfoItem(1, 'expenditure', month, index, key, value)}
                        resetEdit={(month, index, oldData) => resetEdit(1, 'expenditure', month, index, oldData)}
                        saveGeneralInfo={(id, callback) => saveGeneralInfo(1, 'expense', id, callback)}
                        toast={toast}
                    />
                </>
            )}
        </div>
    );
}

if (document.getElementById('actualCostsReconciliation')) {
    var rootEl = document.getElementById('actualCostsReconciliation'); // data attributes below help us
    ReactDOM.render(
        <App>
            <ConfirmationModalProvider>
                <ActualCostsAllocationIndex
                    indexUrl={reconciliationIndexUrl}
                    totalsUrl={reconciliationTotalsUrl}
                    updateTaxUrl={updateTaxUrl}
                    locationsUrl={locationsUrl}
                    filtersUrl={filtersUrl}
                    refreshUrl={refreshUrl}
                    saveAllocationUrl={saveAllocationUrl}
                    dropAllocationUrl={dropAllocationUrl}
                    typeWorkforce={typeWorkforce}
                    typeNonWorkforce={typeNonWorkforce}
                    taxEnabled={taxEnabled}
                    editableGeneralInfo={editableGeneralInfo}
                    updateGeneralDataUrl={updateGeneralDataUrl}
                    configsUrl={configsUrl}
                    uploadUrl={uploadUrl}
                    deleteAllUrl={deleteAllUrl}
                    isFileRequired={isFileRequired}
                    integrationConfigured={integrationConfigured}
                    syncEnabled={syncEnabled}
                    action={action}
                    model={model}
                    toggleUrl={toggleUrl}
                    syncNowUrl={syncNowUrl}
                    syncTypes={syncTypes}
                    confirmationUrl={confirmationUrl}
                    eligibleIdsUrl={eligibleIdsUrl}
                />
            </ConfirmationModalProvider>
        </App>,
        rootEl,
    );
}
